import { generateAbsenceUrlBaseV2 } from "utils/utils";
import type { ApiCallerT } from "shared/infrastructure/api/types";
import type {
  AccrualsApiT,
  LoadAccrualsRequestDtoT,
  LoadAccrualsResponseT,
} from "../types/accruals.types";

export const createAccrualsApi = (apiCaller: ApiCallerT): AccrualsApiT => ({
  load: async (dto: LoadAccrualsRequestDtoT, colaboraInstanceId: string) => {
    const url = generateAbsenceUrlBaseV2("accruals");

    const response = await apiCaller<LoadAccrualsResponseT>(
      url,
      "POST",
      dto,
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
  create: async (dto: LoadAccrualsRequestDtoT, colaboraInstanceId: string) => {
    const url = generateAbsenceUrlBaseV2("accruals");

    const response = await apiCaller<LoadAccrualsResponseT>(
      url,
      "POST",
      dto,
      {},
      { "X-Instance-Id": colaboraInstanceId },
    );

    return response;
  },
});
